import { PostList as PostListComponent, } from '@tribeplatform/react-components/PostList';
export const PostListBlock = PostListComponent;
//# sourceMappingURL=Block.js.map